export const en = {
  "lang.select": "Language",
  "lang.change": "Change language",

  "nav.hot": "Hot",
  "nav.categories": "Categories",
  "nav.marketplace": "Marketplace",
  "nav.fund": "Fund",
  "nav.promote": "Promote",
  "nav.earn": "Earn",
  "nav.referrals": "Referrals",
  "nav.soon": "Soon",
  "nav.login": "Login",
  "nav.dashboard": "Dashboard",
  "nav.getHot": "Get Hot",
  "nav.menu": "Menu",
  "nav.walletBalance": "Heat balance",
  "nav.home": "BeHot.Now home",
  "nav.profile": "Dashboard",
  "nav.messages": "Messages",
  "nav.logout": "Log out",
  "nav.balance": "Balance",

  "footer.tagline": "One place to discover, hire, sell and promote. Get on the board. Get HOT. Get seen.",
  "footer.howItWorks": "How it works",
  "footer.operatedBy": "Operated by",
  "footer.disclosure": "Paid placements are clearly marked as paid. Prices shown in USD.",
  "footer.platform": "Platform",
  "footer.comingSoon": "Coming soon",
  "footer.legal": "Legal",
  "footer.hotNow": "Hot Now",
  "footer.hotHistory": "Hot History",
  "footer.getHot": "Get Hot",
  "footer.referrals": "Referrals",
  "footer.withdrawal": "Right of Withdrawal",
  "footer.terms": "Terms of Service",
  "footer.privacy": "Privacy Policy",
  "footer.cookie": "Cookie Policy",
  "footer.rights": "All rights reserved.",
  "footer.compareLeaderboards": "Compare with other leaderboards",

  "home.h1.q": "What is",
  "home.h1.a1": "It's where",
  "home.h1.anything": "anything",
  "home.h1.a2": "can compete for attention!",
  "home.sub1": "Are you an influencer, public figure or celebrity?",
  "home.sub2":
    "Or do you have a song, gig, profile, brand, startup, app, product, business, event or even just an idea?",
  "home.getItOnCharts": "Get it on the charts",
  "home.now": "Now",
  "home.moreBoosts": "More boosts.",
  "home.higherRanking": "Higher ranking.",
  "home.morePeople": "More people see you.",
  "home.more": "More",
  "home.browseChart": "Browse {label} chart",
  "home.listIt": "LIST IT",
  "home.boostIt": "BOOST IT",
  "home.climb": "CLIMB",
  "home.getSeen": "GET SEEN",
  "home.howItWorks": "How it works",
  "home.generalBoard": "GENERAL BOARD",
  "home.podium.title": "Top 3 on every board",
  "home.podium.sub": "The current podium of each category board.",
  "home.generalBoardSub": "The top listings across every category, ranked by total active Heat.",
  "home.allBoards": "All boards",
  "home.movers.badge": "Just moved",
  "home.movers.title": "New entries & rank changes",
  "home.movers.sub": "Live since the last boost. It stays here until someone new enters or a position changes.",
  "home.movers.new": "New",
  "home.movers.prev": "was #{rank}",
  "home.loadingBoard": "Loading the general board…",

  "lowHeat.title": "Running out of Heat",
  "lowHeat.body":
    "Running out of Heat — invite friends and earn more Heat, or top up your wallet now.",
  "lowHeat.invite": "Invite friends",
  "lowHeat.topUp": "Top up wallet",
  "lowHeat.later": "Later",

  "cookie.title": "We use cookies",
  "cookie.accept": "Accept all",
  "cookie.reject": "Reject non-essential",
  "cookie.settings": "Cookie settings",
  "cookie.save": "Save choices",

  "common.close": "Close",
  "common.loading": "Loading…",
  "hiw.h1": "How BeHot.Now works",
  "hiw.toc": "On this page",
  "hiw.toc.title": "Table of contents",
  "hiw.toc.steps": "The five steps",
  "hiw.toc.rules": "Ranking rules",
  "hiw.toc.entry": "How entry pricing works",
  "hiw.toc.glossary": "Glossary",
  "hiw.toc.pricing": "Pricing",
  "hiw.toc.faq": "FAQ",
  "hiw.toc.roadmap": "What's coming next",
  "hiw.toc.services": "Every service",
  "hiw.toc.contact": "Contact us",
  "hiw.steps.title": "The five steps",
  "hiw.ready.title": "Ready to compete?",
  "hiw.ready.body": "List your project or explore what is trending right now.",
  "hiw.ready.list": "Get listed Now",
  "hiw.ready.browse": "Browse the charts",
  "hiw.rules.title": "Ranking rules",
  "hiw.entry.title": "How board entry pricing works",
  "hiw.entry.intro": "Entering a board is simple, but the price is dynamic. You always pay the lowest active Heat on the board plus the board's increment. This example shows exactly how it works.",
  "hiw.entry.lowest": "Current lowest active Heat on the board",
  "hiw.entry.plus": "+ increment",
  "hiw.entry.increment": "Board increment",
  "hiw.entry.min": "Your minimum entry cost",
  "hiw.entry.note": "If the board is empty or freshly reset, the entry cost is the opening offer — usually 3 Heat — so the first entrants get in cheap before the race heats up.",
  "hiw.heat": "{n} Heat",
  "hiw.glossary.title": "Glossary",
  "hiw.pricing.title": "Pricing",
  "hiw.pricing.oneHeat": "Price of 1 Heat",
  "hiw.pricing.oneHeatNote": "One-off payment · no subscription",
  "hiw.pricing.listing": "Listing price",
  "hiw.pricing.listingNote": "To list your project on a board",
  "hiw.pricing.entry": "Board entry",
  "hiw.pricing.entryValue": "Lowest Heat + increment",
  "hiw.pricing.entryNote": "Example: 12 Heat + 1 = 13 Heat to enter",
  "hiw.pricing.opening": "Opening offer",
  "hiw.pricing.openingNote": "Entry cost on a fresh or empty board",
  "hiw.faq.title": "Frequently asked questions",
  "hiw.roadmap.title": "What's coming next",
  "hiw.soon": "Coming soon",
  "hiw.promote.body": "Buy real promotional actions from creators, posts, stories, shoutouts and collabs, at fixed prices with escrow and proof of delivery.",
  "hiw.promote.more": "Learn more about Promote",
  "hiw.earn.body": "Creators publish a rate card, get booked directly, deliver with proof and withdraw their earnings in USD.",
  "hiw.earn.more": "Learn more about Earn",
  "hiw.services.title": "Every service, explained",
  "hiw.services.intro": "BeHot.Now is more than the board. Here is everything the platform does today, and everything that is on the way.",
  "hiw.services.open": "Open {name}",
  "hiw.contact.title": "Talk to us",
  "hiw.contact.intro": "Pick the service your enquiry is about — including Request support and Contact sales — and we will route it to the right team.",
  "hiw.cta.title": "Ready for position 01?",
  "hiw.cta.button": "Get on a board",
  "stats.liveUsers": "{n} users live",
  "stats.totalVisits": "{n} total visits",
} as const;

export type Dictionary = Record<keyof typeof en, string>;
export type TranslationKey = keyof typeof en;
